// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + chunkId + "." + {"167":"0db4274b","440":"ad515a88"}[chunkId] + ".js";
};